import HttpService from '../base.service/HttpService'

export default class HomeChargingServices extends HttpService {
  getCardHomeCharging (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/HomeCharging/dashboard-persentase'
    return this.get(param, api)
  }

  getChartUnitHC (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/HomeCharging/chart/unit'
    return this.get(param, api)
  }

  getChartTotalKwhHC (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/HomeCharging/chart/total-kwh'
    return this.get(param, api)
  }

  getChartDiskonTotalKwhHC (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/HomeCharging/chart/diskon-kwh'
    return this.get(param, api)
  }

  getDataPelangganHC (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/HomeCharging/data-pelanggan'
    return this.get(param, api)
  }

  getDataDLPDHC (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/HomeCharging/dlpd'
    return this.get(param, api)
  }

  exportDataDLPD (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/HomeCharging/dlpd/export'
    return this.getFile(param, api, param.name)
  }
}
